import type { ThemeMode } from "./palette";

import { DEFAULT_THEME_CONFIG, resolveEffectiveMode } from "./palette";

const AGENT_THEME_MODE_STORAGE_KEY = "replo.agent.themeMode";

function isThemeMode(value: string): value is ThemeMode {
  return value === "light" || value === "dark" || value === "system";
}

export function getAgentThemeMode(): ThemeMode | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(AGENT_THEME_MODE_STORAGE_KEY);
    return raw && isThemeMode(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function setAgentThemeMode(mode: ThemeMode) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(AGENT_THEME_MODE_STORAGE_KEY, mode);
  } catch {
    // Storage can be unavailable in private browsing.
  }
}

export function isAgentBootDark({
  themeMode,
  prefersDark,
}: {
  themeMode: ThemeMode | null;
  prefersDark: boolean;
}): boolean {
  return (
    resolveEffectiveMode({
      mode: themeMode ?? DEFAULT_THEME_CONFIG.mode,
      prefersDark,
    }) === "dark"
  );
}
